import * as React from "react";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {} = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <section className="arraysHeader">
      <span className="arraysHeaderSpanAuto" style={{ width: "20%" }}>
        <div className="arraysHeaderContenair">
          <div className="arrayHeaderInfos">
            <p style={{ cursor: "default" }}>{i18next.t("camera")}</p>
          </div>
        </div>
      </span>
      <span className="arraysHeaderSpanAuto" style={{ width: "10%" }}>
        <div className="arraysHeaderContenair">
          <div className="arrayHeaderInfos">
            <p style={{ cursor: "default" }}>
              {" "}
              {i18next.t("localisation (m)")}
            </p>
          </div>
        </div>
      </span>
      <span className="arraysHeaderSpanAuto" style={{ width: "30%" }}>
        <div className="arraysHeaderContenair">
          <div className="arrayHeaderInfos">
            <p style={{ cursor: "default" }}>{i18next.t("statut")}</p>
          </div>
        </div>
      </span>
      <span className="arraysHeaderSpanAuto" style={{ width: "20%" }}>
        <div className="arraysHeaderContenair">
          <div className="arrayHeaderInfos">
            <p style={{ cursor: "default" }}>{i18next.t("section")}</p>
          </div>
        </div>
      </span>
      <span className="arraysHeaderSpanAuto" style={{ width: "20%" }}>
        <div className="arraysHeaderContenair">
          <div className="arrayHeaderInfos">
            <p style={{ cursor: "default" }}>{i18next.t("ajoutee le")}</p>
          </div>
        </div>
      </span>
    </section>
  );
};

// initialisation des props

Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  cameraListData?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/camera-virtualized-header/component.tsx